module.exports = __webpack_public_path__ + "static/media/set_expectations_square.843df437.png";